module.exports = __webpack_public_path__ + "static/assets/f63f8fa5c482ca8f9a3e84f91cde2496.svg";